export const TiposDeCursos = [
    {text: 'Cursos y Certificaciones', value: 'Cursos y Certificaciones'},
    {text: 'Asesorías Administrativas', value: 'Asesorías Administrativas'},
    {text: 'Cursos Asistencia Técnica Regional', value: 'Cursos Asistencia Técnica Regional'},
    {text: 'Maestrías y Doctorados', value: 'Maestrías y Doctorados'},
    {text: 'Webinars', value: 'Webinars'},
]